import {Component, Input, OnInit} from '@angular/core';
import {combineLatestAll, of} from 'rxjs';

import {PrlDashboardDataService} from '../../services/dashboard/prl-dashboard-data.service';
import {CampaignProfilePrlObj, IdNameMxObj, MxInformationTooltipConfig, TopZoneMxObj} from 'mx-core';
import {PrlProfilesService} from '../../../../shared/services/prl-profiles.service';
import {PrlMarketingToolsService} from '../../../prl-marketing-tools/services/prl-marketing-tools.service';

@Component({
    selector: 'prl-dashboard-top-zones',
    standalone: false,
    templateUrl: './prl-dashboard-top-zones.component.html',
    styleUrl: './prl-dashboard-top-zones.component.scss'
})
export class PrlDashboardTopZonesComponent implements OnInit {

    @Input()
    topZones = new Array<TopZoneMxObj>();

    topZonesConfig: MxInformationTooltipConfig = {
        links: [],
        header: 'Help',
        content: 'label.dashboard.topzones.help'
    };

    constructor(
        private readonly dashboardDataService: PrlDashboardDataService,
        private readonly marketingToolsService: PrlMarketingToolsService,
        private readonly profilesService: PrlProfilesService,
    ) { }

    ngOnInit(): void {
        of(
            this.profilesService.loadNonExpiredCampaigns(),
            this.marketingToolsService.loadProfiles(),
        )
            .pipe(combineLatestAll())
            .subscribe((response) => {
                this.profilesService.setNonExpiredCampaigns(response[0] as IdNameMxObj[]);
                this.marketingToolsService.setProfiles(response[1] as  Map<number, CampaignProfilePrlObj[]>);
            });
    }
}
